import { Icon, IconProps } from '@chakra-ui/react'

export function PersonIconV2(props: IconProps) {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <g clipPath="url(#clip0_419_23587)">
      <path
        d="M16 8.00004C17.4667 8.00004 18.6667 9.20004 18.6667 10.6667C18.6667 12.1334 17.4667 13.3334 16 13.3334C14.5333 13.3334 13.3333 12.1334 13.3333 10.6667C13.3333 9.20004 14.5333 8.00004 16 8.00004ZM16 21.3334C19.6 21.3334 23.7333 23.0534 24 24H7.99999C8.30666 23.04 12.4133 21.3334 16 21.3334ZM16 5.33337C13.0533 5.33337 10.6667 7.72004 10.6667 10.6667C10.6667 13.6134 13.0533 16 16 16C18.9467 16 21.3333 13.6134 21.3333 10.6667C21.3333 7.72004 18.9467 5.33337 16 5.33337ZM16 18.6667C12.44 18.6667 5.33333 20.4534 5.33333 24V26.6667H26.6667V24C26.6667 20.4534 19.56 18.6667 16 18.6667Z"
        fill="currentColor"
      />
      </g>
      <defs>
      <clipPath id="clip0_419_23587">
      <rect width="32" height="32" fill="white"/>
      </clipPath>
      </defs>
    </Icon>
  )
}
